module.exports = __webpack_public_path__ + "30978de74b13ee391131082b7accd15b.png";